import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';
import { authMiddleware } from '@/middleware/authentication';

Vue.use(VueRouter);

const routes: RouteConfig[] = [
  /* 管理者システム */
  // ホーム画面
  {
    path: '/admin',
    name: 'login',
    meta: { isUnauthenticated: true },
    component: () => import('@/views/admin/login/login.view.vue'),
  },
  // パスワード変更画面
  {
    path: '/admin/change-password/:id',
    name: 'change-password',
    component: () =>
      import('@/views/admin/change-password/change-password.view.vue'),
  },
  // 学校一覧画面
  {
    path: '/admin/result-publication/schools',
    name: 'result-publication-school',
    component: () =>
      import('@/views/admin/result-publication/schools.view.vue'),
  },
  // 公開期間登録画面
  {
    path: '/admin/result-publication/period-edit/:id',
    name: 'period-edit',
    component: () =>
      import('@/views/admin/result-publication/period-edit.view.vue'),
  },
  // 強制非公開
  {
    path: '/admin/result-publication/stop/:id',
    name: 'stop',
    component: () => import('@/views/admin/result-publication/stop.view.vue'),
  },
  // 対応状況
  {
    path: '/admin/result-publication/statuses',
    name: 'result-publication-statuses',
    component: () =>
      import('@/views/admin/result-publication/statuses.view.vue'),
  },
  // アクセス状況
  {
    path: '/admin/result-publication/accesses',
    name: 'result-publication-accesses',
    component: () =>
      import('@/views/admin/result-publication/accesses.view.vue'),
  },
  // アクセス状況
  {
    path: '/admin/result-publication/reset',
    name: 'result-publication-reset',
    component: () => import('@/views/admin/result-publication/reset.view.vue'),
  },
  // 周知文書（登録）
  {
    path: '/admin/official-documents/junior-high-school',
    name: 'official-document-junior-high-school',
    component: () =>
      import('@/views/admin/official-documents/junior-high-school.view.vue'),
  },
  {
    path: '/admin/official-documents/senior-high-school',
    name: 'official-document-senior-high-school',
    component: () =>
      import('@/views/admin/official-documents/senior-high-school.view.vue'),
  },
  // 管理者一覧画面
  {
    path: '/admin/result-publication/admin-schools',
    name: 'result-publication-admin-school',
    component: () =>
      import('@/views/admin/result-publication/admin-schools.view.vue'),
  },

  /* 教員システム */
  // ホーム画面
  {
    path: '/user',
    name: 'home',
    meta: { isUnauthenticated: true },
    component: () => import('@/views/user/home/home.view.vue'),
  },
  // リハーサル準備
  {
    path: '/user/result-publication/rehearsal',
    name: 'rehearsal',
    component: () =>
      import('@/views/user/result-publication/rehearsal.view.vue'),
  },
  // 合格発表準備
  {
    path: '/user/result-publication/live',
    name: 'live',
    component: () => import('@/views/user/result-publication/live.view.vue'),
  },
  // 合格
  // 周知文書（登録）
  {
    path: '/user/official-documents/download',
    name: 'official-document-download',
    component: () =>
      import('@/views/user/official-documents/download.view.vue'),
  },
];

const vueRouter = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});
vueRouter.beforeEach(authMiddleware);

export default vueRouter;
